import { Box } from "@chakra-ui/react";
import { RouteMeta } from "@/components";
import { PRICING_FAQ, PRICING_FAQ_LABEL, PRICING_META } from "@/content";
import { DiscordCta, Footer, Nav, SkipLink } from "@/layout";
import { BackLink, Faq, Plans, PricingHero } from "@/sections";

export const PricingPage = () => (
  <>
    <RouteMeta meta={PRICING_META} />
    <SkipLink />
    <Nav />
    <Box as="main" id="main">
      <PricingHero />
      <Plans />
      <Faq entries={PRICING_FAQ} label={PRICING_FAQ_LABEL} />
      <BackLink />
      <DiscordCta />
    </Box>
    <Footer />
  </>
);
